import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import useWindowSize from "../../hooks/useWindowSize";

export default function Nav() {
	const { i18n, t } = useTranslation();
	const [expanded, expand] = useState(false);
	const [width] = useWindowSize();

	const mobile = width < 1024;

	useEffect(() => {
		if (mobile) expand(false);
	}, [mobile]);

	function close() {
		expand(false);
	}

	return (
		<nav
			className="max-lg:flex-col z-10 sticky top-0 bg-[#343a40] shadow-lg grow flex
			lg:justify-center lg:space-x-4 p-4 font-bold"
		>
			{mobile && (
				<button
					className="w-5/6 text-left"
					onClick={() => expand(!expanded)}
				>
					<i className="bi bi-list text-xl"></i>
				</button>
			)}

			{(!mobile || expanded) && (
				<>
					<a
						href="#home"
						className="hover:text-shadow hover:scale-110 shadow-white max-lg:mt-4"
						onClick={close}
					>
						{t("home")}
					</a>
					<a
						href="#xp"
						className="hover:text-shadow hover:scale-110 shadow-white"
						onClick={close}
					>
						{t("xp.title")}
					</a>
					<a
						href="#cursus"
						className="hover:text-shadow hover:scale-110 shadow-white"
						onClick={close}
					>
						{t("formations.title")}
					</a>
					<a
						href="#realisations"
						className="hover:text-shadow hover:scale-110 shadow-white"
						onClick={close}
					>
						{t("realisations.title")}
					</a>
					<a
						href="#certifications"
						className="hover:text-shadow hover:scale-110 shadow-white"
						onClick={close}
					>
						{t("certifications.title")}
					</a>
					<a
						href="#skills"
						className="hover:text-shadow hover:scale-110 shadow-white"
						onClick={close}
					>
						{t("skills")}
					</a>
					<a
						href="#contacts"
						className="hover:text-shadow hover:scale-110 shadow-white"
						onClick={close}
					>
						Contacts
					</a>
				</>
			)}
			<button
				className="absolute right-4 flex hover:text-shadow hover:scale-110 shadow-white"
				onClick={() =>
					i18n.changeLanguage(i18n.language === "en" ? "fr" : "en")
				}
			>
				{i18n.language.toUpperCase()}
				<img
					className="ml-2 w-6 h-4 mt-1.5"
					src={`imgs/${i18n.language}.jpg`}
					alt={i18n.language}
				></img>
			</button>
		</nav>
	);
}
